import styles from "./footingContainer.module.css";

const FootingContainer = ({ children, ...rest }) => {
  return <div className={styles.footingContainer}>{children}</div>;
};

export default FootingContainer;
